import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {

  
  transform(value: string): string {
    const date = new Date(`2000-01-01T${value}`);

    const timeFormatted = new DatePipe('en-US').transform(date, 'h:mm a');

    return timeFormatted || value;
  }

}
